(function ($) {

    $(document).ready(function () {

        $('.parallax-background').parallaxBackground();
        $('.parallax-content').parallaxContent({
            shift: -30,
            duration: 2
        });

    });

})(jQuery);


// WEBPACK FOOTER //
// ./src/js/custom/envision_message.es6